var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"overlay",style:(_vm.style)},[_c('pulse-loader',{staticClass:"spinner",attrs:{"size":_vm.size,"color":_vm.color}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }